/* eslint-disable camelcase */
 //const intfc_prefix_common = 'https://api-app.people.cn'
// if (process.env.NODE_ENV === 'pre') {
//   // eslint-disable-next-line camelcase
//const  intfc_prefix_common = 'https://pre-api-app.people.cn'
// } else if (process.env.NODE_ENV === 'development') {
//   // eslint-disable-next-line camelcase
//const intfc_prefix_common = 'https://api-app.peopleurl.cn'
//const intfc_prefix_common = 'https://dev-api-app.peopleurl.cn'
// } else if (process.env.NODE_ENV === 'testing') {
//   // eslint-disable-next-line camelcase
// intfc_prefix_common = 'https://api-app.peopleurl.cn'
// } else if (process.env.NODE_ENV === 'production') {
//   // eslint-disable-next-line camelcase
const intfc_prefix_common = 'https://api-app.people.cn' // 测主式
// }

export {
  // eslint-disable-next-line camelcase
  intfc_prefix_common
}
